import React, { useState } from 'react';
import { createDataTable } from '../DataTable';
import { useAsyncStateWithIsLoading } from 'utils/hooks';
import { BygrProfile } from 'types';
import { Button, CustomLink, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { getProfiles, getProfilesExportUrl } from 'services/profiles';
import { faPlus } from '@fortawesome/pro-light-svg-icons';
import AddProfileModal from './AddProfileModal';

const DataTable = createDataTable<BygrProfile>();

const ProfileTable: React.FC<{}> = () => {
    const [tableState, setTableState] = useState(DataTable.getInitialState('name'));
    const [data, , reload, isLoading] = useAsyncStateWithIsLoading(() => getProfiles(tableState), [tableState], null);
    const [addProfileModalIsOpen, setAddProfileModalIsOpen] = useState(false);

    if (!data) {
        return <LoadingIndicator />;
    }

    return (
        <div>
            <h3>Seller profiles</h3>
            <DataTable
                exportUrl={getProfilesExportUrl(tableState)}
                hasSearchField
                isLoading={isLoading}
                data={data.items}
                onStateChange={setTableState}
                state={tableState}
                totalItemCount={data.totalCount}
                className="table style-3">
                <DataTable.Column header="ID" field="id" sortable />
                <DataTable.Column
                    header="Name"
                    field="name"
                    sortable
                    renderer={({ row, value }) => <CustomLink to={`/profiles/${row.id}`}>{value}</CustomLink>}
                />
                <DataTable.Column
                    header="Is Paying"
                    field="isPaying"
                    sortable
                    renderer={({ value }) => (value ? 'Yes' : 'No')}
                />

                <DataTable.Column
                    header="Number Of Members"
                    field="numberOfMembers"
                    sortable
                    renderer={({ value }) => value}
                />
            </DataTable>

            <Button color="primary" onClick={() => setAddProfileModalIsOpen(true)} icon={faPlus}>
                Create new profile
            </Button>
            <AddProfileModal onSave={reload} isOpen={addProfileModalIsOpen} toggle={() => setAddProfileModalIsOpen(false)} />
        </div>
    );
};

export default ProfileTable;
